<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconParticipant_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M16.59 8.595a4.601 4.601 0 0 1-4.596 4.597 4.601 4.601 0 0 1-4.597-4.597A4.602 4.602 0 0 1 11.994 4a4.6 4.6 0 0 1 4.596 4.595Zm-4.596 6.562c4.068 0 6.328.952 7.527 2.234l.021.023c.346.37.88.943 1.101 2.356a1.254 1.254 0 0 1-1.239 1.439H4.584a1.254 1.254 0 0 1-1.239-1.438c.218-1.396.74-1.962 1.061-2.313l.031-.033c1.191-1.299 3.455-2.268 7.557-2.268Z"
        clip-rule="evenodd"
    />
</svg>
